import { useMutation } from 'react-query';

import { postV2ApiCompanyIdInternationalTransfersKycReviews } from 'src/client/spendesk-api';

const fetchCreateKycReviews = async ({
  companyId,
  redirectUserTo,
}: {
  companyId: string;
  redirectUserTo: string;
}) => {
  const response = await postV2ApiCompanyIdInternationalTransfersKycReviews({
    path: { companyId },
    body: {
      redirectUserTo,
    },
  });

  if (response.statusCode !== 200) {
    throw new Error('Failed to create a Wise KYC review');
  }

  return response.body.data;
};

export const useUpdateKycReview = ({
  companyId,
  redirectUserTo,
}: {
  companyId: string;
  redirectUserTo: string;
}) => {
  return useMutation({
    mutationKey: ['kyc-reviews', companyId, redirectUserTo],
    mutationFn: async () =>
      fetchCreateKycReviews({ companyId, redirectUserTo }),
  });
};
